import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 edit_ussd_code: { message: "idle" },
};

export const edit_ussd_code_Slice = createSlice({
 name: "edit_ussd_code",
 initialState,
 reducers: {
  success_edit_ussd_code: (state, action) => {
   state.edit_ussd_code = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_edit_ussd_code: (state, action) => {
   state.edit_ussd_code = { status: app_consts.FAIL, message: action.payload };
  },
  reset_edit_ussd_code: (state) => {
   state.edit_ussd_code = { status: app_consts.IDLE };
  },
  loading_edit_ussd_code: (state) => {
   state.edit_ussd_code = { status: app_consts.LOADING };
  },
 }
});

export const { success_edit_ussd_code, fail_edit_ussd_code, reset_edit_ussd_code, loading_edit_ussd_code } = edit_ussd_code_Slice.actions;

export default edit_ussd_code_Slice.reducer;